import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Section, Card } from '../components/ui';
import changeTile from '../assets/images/home-tile-change.jpg';
import capitalTile from '../assets/images/home-tile-capital.jpg';
import automationTile from '../assets/images/home-tile-automation.jpg';
import analyticsTile from '../assets/images/home-tile-analytics.jpg';
import './Productline.css';

const productline = [
    {
        title: 'Change & adoption',
        description:
            'Programmes that land: leadership alignment, ways of working, and adoption measured where work happens—not only in slide decks.',
        ctaLabel: 'Consulting',
        linkTo: '/services/consulting',
        image: changeTile,
        imageAlt: 'Daylit workshop with a simple process on the whiteboard',
    },
    {
        title: 'Capital & scale',
        description:
            'When growth needs more than advice—angel and PE engagement with milestones, reporting, and judgment aligned to your risk profile.',
        ctaLabel: 'Capital',
        linkTo: '/services/capital',
        image: capitalTile,
        imageAlt: 'Modern glass office building on a bright plaza',
    },
    {
        title: 'Automation & AI',
        description:
            'Workflow automation and AI embedded in operations—scoped to outcomes, owned by teams, and sustained after go-live.',
        ctaLabel: 'Technology',
        linkTo: '/services/technology',
        image: automationTile,
        imageAlt: 'Industrial robotic arm in a daylit operations space',
    },
    {
        title: 'Analytics & decisions',
        description:
            'Dashboards and analytics products that answer the questions leadership actually asks—built on data you can trust.',
        ctaLabel: 'Technology',
        linkTo: '/services/technology',
        image: analyticsTile,
        imageAlt: 'Bright meeting room with a wall-mounted analytics display',
    },
];

const ProductCard = ({ product, index }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
        >
            <Card variant="interactive" className="product-card">
                <div className="product-image-wrapper">
                    <img
                        src={product.image}
                        alt={product.imageAlt}
                        className="product-image"
                        loading="lazy"
                    />
                    <div className="product-image-overlay"></div>
                </div>
                <div className="product-content">
                    <h3 className="product-title">{product.title}</h3>
                    <p className="product-description">{product.description}</p>
                    <Link to={product.linkTo} className="product-price-link">
                        <span className="product-price">{product.ctaLabel}</span>
                    </Link>
                </div>
            </Card>
        </motion.div>
    );
};

const Productline = () => {
    return (
        <Section id="capabilities" variant="default" className="productline-section anchor-target">
            <div className="productline-wrapper">
                <motion.h2
                    className="productline-heading"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-100px' }}
                    transition={{ duration: 0.6 }}
                >
                    <span className="productline-heading-primary">Where we help.</span>
                    <span className="productline-heading-secondary"> Across consulting, capital, and technology.</span>
                </motion.h2>

                <div className="productline-grid">
                    {productline.map((product, index) => (
                        <ProductCard key={product.title} product={product} index={index} />
                    ))}
                </div>
            </div>
        </Section>
    );
};

export default Productline;
